const coordinate = {
  namespaced: true,
  state: {
    coordinate: [],
    zoomLocation: {lat: null, lon: null},
    zoom: null
  },
  getters: {
    getCoordinate: (state) => state.coordinate,
    getZoom: (state) => state.zoom || 16 // 16 is default zoom
  },
  mutations: {
    setCoordinate (state, coordinate) {
      state.coordinate = coordinate
    },
    setZoomLocation (state, location) {
      state.zoomLocation = location
    },
    setZoom (state, zoom) {
      state.zoom = zoom
    }
  },
  actions: {
    setCoordinate ({ commit }, coordinate) {
      commit('setCoordinate', coordinate)
    },
    setZoomLocation ({ commit }, location) {
      commit('setZoomLocation', location)
    },
    setZoom ({ commit }, zoom) {
      commit('setZoom', zoom)
    }
  }
}

export default coordinate



// WEBPACK FOOTER //
// ./src/vuex/coordinate.js